import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import Ribbon from "@/components/sections/Ribbon";
import About from "@/components/sections/About";
import MNEFormula from "@/components/sections/MNEFormula";
import Services from "@/components/sections/Services";
import GroupClasses from "@/components/sections/GroupClasses";
import Testimonials from "@/components/sections/Testimonials";
import GoogleReviews from "@/components/sections/GoogleReviews";
import Contact from "@/components/sections/Contact";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain bg-cream text-ink antialiased">
      <Navbar />
      <main>
        <Hero />
        <Ribbon />
        <About />
        <MNEFormula />
        <Services />
        <GroupClasses />
        <Testimonials />
        <GoogleReviews />
      </main>
      <Contact />
    </div>
  );
}

export default App;
